jQuery(document).ready(function($){

    function loadSports(pageNo) {
        var sorteren = $('#sorteren').val();
        var keyword = $('#keyword').val();

        $("#page_no").val(pageNo);

        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/wp/wp-admin/admin-ajax.php",
            data: {
                action: 'filter_sports',
                pageNo: pageNo,
                sorteren: sorteren,
                keyword: keyword
            },
            success: function(data){
                $(".sportsfilter").html(data.html);
                $(".numberCount").text(data.start + "-" + data.total + " van " + data.total + " resultaten");
                // $("#pagination").html(buildPagination(data.max, pageNo));
            }
        });  
    }

    // Search
    $("#keyword").on("keyup", function(){ 
        loadSports(1);
    });

    // Sort
    $("#sorteren").on("change", function(){ 
        loadSports(1);
    });

    // Pagination click
    $(document).on("click", "#pagination .page-link", function(e){
        e.preventDefault();
        var pageNo = parseInt($(this).data("page"));
        loadSports(pageNo);
    });

    function buildPagination(max, currentPage) {
        var html = '';

        // Prev
        if(currentPage > 1){
            html += '<a href="#" class="page-link prev" data-page="' + (currentPage - 1) + '"><img src="/web/app/themes/salient-child/dist/images/prevArrow.svg" /></a> ';
        }

        // Page numbers
        for(var i=1; i<=max; i++){
            html += '<a href="#" class="page-link ' + (i===currentPage?'active':'') + '" data-page="'+i+'">'+i+'</a> ';
        }

        // Next
        if(currentPage < max){
            html += '<a href="#" class="page-link next" data-page="' + (currentPage + 1) + '"><img src="/web/app/themes/salient-child/dist/images/NextArrow.svg" /></a> ';
        }

        return html;
    }

});
